export interface TrackerApiRequest {
    /**
     * 事件类型，属于哪个功能模块的事件
     */
    event_type: string;

    /**
     * 事件名字
     */
    source_type?: string;

    /**
     * 其他参数，普通string
     */
    other_param?: string;

    /**
     * 事件详情。jsonString传递的数据量大推荐使用这个
     */
    event_detail_str?: string;

    /**
     * 来源项目、模块类型
     */
    module_type: string;
}

export interface TrackerApiResponse {}

export interface TrackerApi {
    /**
     * 跟踪事件
     * @param data 请求参数
     * @returns Promise
     */
    trackEvent(data: TrackerApiRequest): Promise<TrackerApiResponse>;
}

export const TrackerApi = Symbol('TrackerApi');
